module.exports = __webpack_public_path__ + "static/background-3-974a7d3c973e2600e2c00b25d7c2fea7.svg";